import { FC, memo } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

export const FilterSkeleton: FC = memo(() => (
  <Skeleton variant="rect" width="100%" height="48px" />
));
